import type { SupabaseClient, Session } from "@supabase/supabase-js";

const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));

export async function getStableSession(
  supabase: SupabaseClient,
  opts: { retries?: number; delay?: number } = {}
): Promise<Session | null> {
  const retries = opts.retries ?? 3;
  const delay = opts.delay ?? 250;

  for (let i = 0; i < retries; i++) {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) console.warn("getSession error:", error.message);
    if (session) return session;

    if (i === 0) {
      // single refresh attempt early
      try {
        const { data: refreshed, error: re } = await supabase.auth.refreshSession();
        if (!re && refreshed?.session) return refreshed.session;
      } catch {}
    }
    await sleep(delay);
  }
  return null;
}